import React from "react"

import BaseSvgIcon from "../Base"

const TotalReward = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"></path>
  </BaseSvgIcon>
)

export default TotalReward
